import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { otherDeductionsDetailInputList4 } from '../../../../common/data';

import InputItemSection from '../OtherInputItemSection';
import DetailTitleSection from '../../../../components/DetailTitleSection';
import Typography from '../../../../components/common/Typography';
import Radio from '../../../../components/common/Radio';
import Chips from '../../../../components/common/Chips';
import TextField from '../../../../components/common/TextField';
import { getOtherDeductionsData4, saveOtherDeductionsData } from '../otherDeductionsSlice';
import { formatNumber, getAlertMessageFunction, magamCertifyCheck } from '../../../../common/Util';
import DetailButtonSection from '../../../../components/DetailButtonSection';
import SlideRightDialog from '../../../../components/common/SlideRightDialog';
import { setIsDataModified } from '../../../common/commonSlice';

// 우리사주 소기업, 소상공인
const Type4 = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('deductions/other');
  const { t: tCommon } = useTranslation('common');
  const inputList = otherDeductionsDetailInputList4(t);
  const { s11_4Data, detailReload } = useSelector(state => state.otherDeductions);
  const { isMagam, isCertify } = useSelector(state => state.common);
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    //초기는 메인에서 받는다. 삭제, 저장할때만 다시받음
    if (detailReload != -1) {
      dispatch(getOtherDeductionsData4());
    }
  }, [detailReload]);

  useEffect(() => {
    if (isOpen) {
      const { htmVentureFlag } = s11_4Data;
      let htm175 = s11_4Data.htm175 || '';
      if (htmVentureFlag != undefined) {
        htm175 = htmVentureFlag;
      }
      setDataList({
        htm017: s11_4Data.htm017,
        htm048: s11_4Data.htm048,
        htm053: s11_4Data.htm053,
        htm143: s11_4Data.htm143,
        htm171: s11_4Data.htm171 || '',
        htm172: s11_4Data.htm172 || '',
        htm173: s11_4Data.htm173 || '',
        htm175: htm175,
        htm180: s11_4Data.htm180 || '',
        htm181: s11_4Data.htm181 || '',
        htmEtcType: 'S1140',
      });
    }
  }, [s11_4Data, isOpen]);

  const handleChange = e => {
    let { name, value } = e.target;

    value = value.replace(/,/g, '');

    dispatch(setIsDataModified(true));
    setDataList({ ...dataList, [name]: value });
  };

  const handleSave = async () => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    const alertMessage = getAlertMessageFunction();
    let formData = [dataList];
    try {
      const resultAction = await dispatch(saveOtherDeductionsData({ formData })).unwrap();

      if (resultAction.resultCode === 'OK') {
        alertMessage(tCommon('alertMessage.saveSuccess'), 'success');
        onClose();
      } else {
        alertMessage(tCommon('alertMessage.saveFail'), 'error');
      }
    } catch (error) {
      alertMessage(tCommon('alertMessage.saveFail'), 'error');
      console.error('저장 중 오류 발생: ', error);
    }
  };

  return (
    <SlideRightDialog isOpen={isOpen} onClose={onClose}>
      <div className="displayFlexColumn" style={{ gap: '24px' }}>
        <DetailTitleSection title={`${t('detail.type4.title')}`} />
        <Typography variant="body2Medium">{t('detail.type4.radioTitle2')}</Typography>
        <div className="displayFlex" style={{ gap: '40px', justifyContent: 'flex-end' }}>
          <Radio
            label={tCommon('radioGroup.yes')}
            size="medium"
            checked={dataList.htm175 == '1'}
            value="1"
            name="htm175"
            disabled={true}
            onChange={() => {}}
          />
          <Radio
            label={tCommon('radioGroup.no')}
            size="medium"
            checked={dataList.htm175 == '' || dataList.htm175 == '2'}
            value=""
            name="htm175"
            onChange={() => {}}
            disabled={true}
          />
        </div>
        {/* 우리사주조합 출연금 */}
        <TextField
          size="small"
          label={t('detail.type4.inputLabel1') + t('detail.type4.inputLabel6')}
          value={formatNumber(dataList.htm017)}
          // onChange={handleChange}
          name="htm017"
          disabled
        />
        <TextField
          size="small"
          label={t('detail.type4.inputLabel1') + t('detail.type4.inputLabel7')}
          value={formatNumber(dataList.htm181)}
          onChange={handleChange}
          name="htm181"
          // disabled
        />
        <Typography variant="body2Medium" style={{ whiteSpace: 'pre-wrap' }}>
          {t('detail.type4.radioLabel3')}
        </Typography>
        <div className="displayFlex" style={{ gap: '40px', justifyContent: 'flex-end' }}>
          <Radio
            label={tCommon('radioGroup.yes')}
            size="medium"
            checked={dataList.htm173 == '1'}
            value="1"
            name="htm173"
            onChange={handleChange}
          />
          <Radio
            label={tCommon('radioGroup.no')}
            size="medium"
            checked={dataList.htm173 != '1'}
            value="2"
            name="htm173"
            onChange={handleChange}
          />
        </div>
        <InputItemSection
          dataList={dataList}
          inputList={inputList}
          setDataList={setDataList}
          addButton={true}
          onChange={handleChange}
        />
        {/* 지역건강보험 */}
        <div className="displayFlexColumn" style={{ gap: '16px' }}>
          <Typography variant="body2Medium">{t('detail.type4.inputLabel4')}</Typography>
          <Chips color="warning">{t('detail.type4.chips')}</Chips>
          <TextField
            size="small"
            value={formatNumber(dataList.htm143)}
            name="htm143"
            // onChange={handleChange}
            disabled
          />
        </div>
        {/* 국민연금 지역가입자 */}
        <div className="displayFlexColumn" style={{ gap: '16px' }}>
          <Typography variant="body2Medium">{t('detail.type4.inputLabel5')}</Typography>
          <TextField size="small" value={formatNumber(dataList.htm180)} name="htm180" disabled />
        </div>
        <DetailButtonSection onSave={handleSave} onClose={onClose} />
      </div>
    </SlideRightDialog>
  );
};

export default Type4;
